import apiClient from './client'

export const settingsService = {
  // Réglages globaux de la plateforme (admin)
  getApp:    ()     => apiClient.get('/settings/app'),
  updateApp: (data) => apiClient.put('/settings/app', data),
}

export default settingsService
